/**
 * The different levels for time-dependent warnings and hints.
 *
 * @readonly
 * @enum {string}
 */
export const RdtTimesWarningLevels = {
    NO_WARNING: 'NO_WARNING',
    SOON_OVERDUE: 'SOON_OVERDUE',
    OVERDUE: 'OVERDUE'
}
Object.freeze(RdtTimesWarningLevels)
